import React from 'react';
import { GetServerSideProps } from 'next';
import StoreLocator from '@/storeLocator/StoreLocator';
import initializePage from '@/common/pageSetup';

const StoreLocatorPage = () => (
        <>
            <StoreLocator />
        </>
    );

export default StoreLocatorPage;

export const getServerSideProps: GetServerSideProps = (ctx) => initializePage(ctx, 'locator');